import { useEffect, useState } from "react";
import { toast } from "sonner";

import { VISIT_COUNT_ENDPOINT } from "@config/kvs";

interface VisitCountPayload {
  visitCount?: number | string;
}

function parseVisitCount(payload: VisitCountPayload): number | null {
  if (typeof payload.visitCount === "number" && Number.isFinite(payload.visitCount)) {
    return payload.visitCount;
  }
  if (typeof payload.visitCount === "string") {
    const parsed = Number.parseInt(payload.visitCount, 10);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

export function VisitCounter() {
  const [count, setCount] = useState<number | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let canceled = false;

    async function fetchVisitCount() {
      try {
        const response = await fetch(VISIT_COUNT_ENDPOINT, { method: "GET" });
        if (!response.ok) {
          throw new Error(`Unexpected status ${response.status}`);
        }
        const data = (await response.json()) as VisitCountPayload;
        if (!canceled) {
          const next = parseVisitCount(data);
          if (next === null) {
            throw new Error("Invalid payload");
          }
          setCount(next);
          setFailed(false);
        }
      } catch (error) {
        if (!canceled) {
          // Silently log to console for debugging
          console.warn("visit counter fetch failed", error);
          // Show a subtle toast to the user
          toast.error("无法获取访问统计", {
            description: "网络请求失败或服务不可用",
            duration: 4000,
          });
          setFailed(true);
        }
      }
    }

    fetchVisitCount();

    return () => {
      canceled = true;
    };
  }, []);

  if (failed || count === null) {
    return null;
  }

  return <span className="text-xs text-slate-500 sm:text-sm">访问次数：{count}</span>;
}
